// Admin Dashboard Page - Redesigned with Gaming/Tech Aesthetic

import { AdminDashboard } from './Dashboard.new';

export default function AdminDashboardPage() {
  return <AdminDashboard />;
}
